<template>
	<div class="row items-center justify-center full-height vimeo-page">
		<div class="col-12 container">
			<VimeoPlayer
				class="vimeo-player"
				ref="vimeo"
				:options="{ responsive: true, start_time: activity.current_time }"
				:video-url="activity.resource"
				@timeupdate="onTimeUpdate"
				@ended="onEnded"
				@seeked="onSeeked"
				@play="onPlay"
				@pause="onPause"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { vueVimeoPlayer } from 'vue-vimeo-player'
export default {
	name: 'WebinarVimeoPlayer',
	props: ['activity'],

	data() {
		return {
			current_time: 0,
			duration: 0,
			interval: null,
		}
	},

	components: {
		VimeoPlayer: vueVimeoPlayer,
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
		}),

		getPlayerClass() {
			return this.$q.platform.is.mobile ? 'vimeo-mobile' : 'vimeo'
		},
	},

	methods: {
		onTimeUpdate(val) {
			if (val.seconds - 1 < this.current_time && val.seconds > this.current_time) {
				this.current_time = val.seconds
			}
			this.duration = val.duration
		},

		onPlay() {
			this.interval = setInterval(() => {
				this.sendPosition()
			}, 15000)
		},

		onPause() {
			this.sendPosition()
			clearInterval(this.interval)
		},

		onEnded() {
			this.$q.loading.show()
			this.sendPosition()
			clearInterval(this.interval)
			if (!this.activity.user_watch) {
				setTimeout(() => {
					this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
						this.activity,
						{ user_watch: true },
					])
					this.$emit('finish')
					this.$q.loading.hide()
				}, 500)
			}
			this.$q.loading.hide()
		},

		onSeeked(val, player) {
			if (!this.activity.user_watch) {
				if (this.current_time < val.seconds) {
					player.setCurrentTime(this.current_time)
				}
			}
		},

		sendPosition() {
			if (
				this.$isInvalidNumericString(this.current_time) ||
				this.$isInvalidNumericString(this.duration)
			)
				return

			if (this.current_time != 0 && this.current_time != '') {
				let url = ''
				let id_trail = ''
				let id_course = ''
				let fd = new FormData()

				fd.append('current_time', this.current_time)
				fd.append('total_time', this.duration)
				fd.append('id_group_training_module', this.activity.type_id)

				if (this.$route.params.id_trail) id_trail = this.$route.params.id_trail
				if (this.$route.params.id) id_course = this.$route.params.id

				if (id_trail === '') {
					url = `/etraining_courses/group_training/${id_course}/set_group_training_module_user_progress/`
				} else {
					url = `/etraining_trails/trail/${id_trail}/group_training/${id_course}/set_group_training_module_user_progress/`
				}

				this.$axios
					.post(url, fd)
					.then((response) => {
						this.updatePosition()
					})
					.catch((e) => {
						console.log(e)
					})
			}
		},

		updatePosition() {
			const activities = JSON.parse(JSON.stringify(this.activities))
			const obj = activities.find((obj) => obj.hierarchy_order === this.hierarchy_order)
			if (obj) {
				obj.current_time = this.current_time
				this.$store.dispatch('activities/SET_ACTIVITIES', [activities])
			}
		},
	},

	beforeDestroy() {
		clearInterval(this.interval)
	},
}
</script>

<style scoped>
.vimeo-page {
	width: 112%;
}
.container {
	align-items: center;
	display: contents;
}
.vimeo-player {
	width: 120%;
	margin-right: 10%;
}
</style>
